import React from "react";
import { AiFillGift, AiOutlineMail } from "react-icons/ai";

import CollectionsIcon from '@mui/icons-material/Collections';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import { FaUpload } from "react-icons/fa";


const SHARED_ICONS = {
  AiFillGift: <AiFillGift />,
  AiOutlineMail: <AiOutlineMail />,
  CollectionsIcon: <CollectionsIcon />,
  CameraAltIcon: <CameraAltIcon />,
  DeleteIcon: <DeleteIcon />,
  FaUpload:<FaUpload/>
};

export default SHARED_ICONS;
